import classNames from 'classnames';
import Link from 'next/link';
import { FC, useCallback, useEffect, useState } from 'react';

import Icon, { IconType } from '@/components/icons';
import { replaceOrAddLocale, useLocale } from '@/helpers/LangHelper';
import { useWindowSize } from '@/hook/useWindowSize';
import styles from './b2b-top-navigation.module.scss';
import { BusinessHubPrimaryActions } from './business-hub-primary-actions/business-hub-primary-actions';
import { BuilderModel } from '@/utils/Builder';
import { BusinessAccessPrimaryActions } from './business-access-primary-actions/business-access-primary-actions';

interface Props {
    signupLink?: string;
    page: any;
    model: string;
}

export const B2BTopNavigation: FC<Props> = (props) => {
    const { signupLink, page, model } = props;

    const [isMobileMenuActive, setIsMobileMenuActive] = useState(false);
    const [needCloseMobileMenu, setNeedCloseMobileMenu] = useState(false);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const { width = 0 } = useWindowSize();
    const [scrollY, setScrollY] = useState<number>(0);
    const { locale } = useLocale();

    useEffect(() => {
        if (width < 1200) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [width]);

    useEffect(() => {
        if (isMobile) {
            if (needCloseMobileMenu) {
                setNeedCloseMobileMenu(false);
                setIsMobileMenuActive(false);
            }
        } else {
            setNeedCloseMobileMenu(true);
            if (isMobileMenuActive) {
                setIsMobileMenuActive(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);

    useEffect(() => {
        const body = document.body;
        if (!body) {
            return;
        }

        if (isMobileMenuActive) {
            body.classList.add('lock-scroll');
        } else {
            body.classList.remove('lock-scroll');
        }
    }, [isMobileMenuActive]);

    useEffect(() => {
        document.addEventListener('scroll', onScroll);
        onScroll();

        return () => {
            document.removeEventListener('scroll', onScroll);
        };
    }, []);

    const onScroll = useCallback(() => {
        setScrollY(window.scrollY);
    }, []);

    const handleClickToggleMenu = () => {
        setIsMobileMenuActive((oldState) => !oldState);
    };

    return (
        <div className={styles.container} style={{ '--bh-scroll-y': `${scrollY}px` } as any}>
            <div className={styles.box}>
                <Link href={replaceOrAddLocale('/business', locale)} className={styles.logo} aria-label="Home">
                    <Icon type={IconType.AfterpayLogo} />
                </Link>

                {model === BuilderModel.BUSINESS_HUB ? (
                    <BusinessHubPrimaryActions page={page} signupLink={signupLink} isMobile={isMobile} isMobileMenuActive={isMobileMenuActive} />
                ) : (
                    <BusinessAccessPrimaryActions isMobile={isMobile} isMobileMenuActive={isMobileMenuActive} onToggleMenu={handleClickToggleMenu} />
                )}

                <div className={classNames(styles.hamburger, { [styles.active]: isMobileMenuActive })} onClick={() => handleClickToggleMenu()}>
                    <div className={styles.iconMenu}>
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            </div>
        </div>
    );
};
